
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MasterView from './pages/MasterView';
import PlayerView from './pages/PlayerView';
import VTTPlayerView from './pages/VTTPlayerView';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MasterView />} />
      <Route path="/player" element={<PlayerView />} />
      <Route path="/vtt" element={<VTTPlayerView />} />
    </Routes>
  );
};

export default App;
